import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  // Fail loudly in dev — silent misconfig is the worst outcome.
  console.error("Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY in .env.local");
}

// Replace supabase-js's default `navigator.locks` lock with a tab-local
// promise queue. The default lock is browser-wide and shared across all
// tabs on the origin; a stale or hung tab (or a tab still running the
// previous deploy's bundle) can hold it and make every auth call in this
// tab sit for the 10s lockAcquireTimeout before throwing. Auth state is
// already persisted to localStorage so cross-tab consistency is preserved
// via the storage event; we don't need a cross-tab mutex on top of that.
let lockChain: Promise<unknown> = Promise.resolve();
function inProcessLock<R>(_name: string, _acquireTimeout: number, fn: () => Promise<R>): Promise<R> {
  const run = lockChain.then(fn, fn);
  lockChain = run.catch(() => undefined);
  return run;
}

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    lock: inProcessLock,
  },
});
